import { EVENT_FIELDS } from "../../constants/analytics.es.js";
import profileFields from "../../constants/profileFields.es.js";
const profileToAnalyticsMapping = {
  [profileFields.ACTUAL_DEBT]: EVENT_FIELDS.ACTUAL_DEBT,
  [profileFields.ADDRESS]: EVENT_FIELDS.FORM_ADDRESS,
  [profileFields.CEREBRO_PID]: EVENT_FIELDS.CEREBRO_PID,
  [profileFields.CITY]: EVENT_FIELDS.FORM_CITY,
  [profileFields.COAPP_CREDIT_PULL_ATTEMPTS_REMAINING]: EVENT_FIELDS.COAPP_CREDIT_PULL_ATTEMPTS_REMAINING,
  [profileFields.COAPP_DATE_OF_BIRTH]: EVENT_FIELDS.FORM_COAPP_DATE_OF_BIRTH,
  [profileFields.COAPP_FIRST_NAME]: EVENT_FIELDS.FORM_COAPP_FIRST_NAME,
  [profileFields.COAPP_LAST_NAME]: EVENT_FIELDS.FORM_COAPP_LAST_NAME,
  [profileFields.CREDIT_PULL_ATTEMPTS_REMAINING]: EVENT_FIELDS.CREDIT_PULL_ATTEMPTS_REMAINING,
  [profileFields.CREDIT_REPORT_ID]: EVENT_FIELDS.CREDIT_REPORT_ID,
  [profileFields.CURRENT_OR_PAST_DUE]: EVENT_FIELDS.FORM_DAYS_BEHIND,
  [profileFields.DATE_OF_BIRTH]: EVENT_FIELDS.FORM_DATE_OF_BIRTH,
  [profileFields.EMAIL]: EVENT_FIELDS.FORM_EMAIL,
  [profileFields.ESTIMATED_DEBT]: EVENT_FIELDS.FORM_ESTIMATED_DEBT_INITIAL,
  [profileFields.FDR_APPLICANT_ID]: EVENT_FIELDS.FDR_APPLICANT_ID,
  [profileFields.FDR_ELIGIBLE]: EVENT_FIELDS.FDR_ELIGIBLE,
  [profileFields.FIRST_NAME]: EVENT_FIELDS.FORM_FIRST_NAME,
  [profileFields.IDENTITY_ANSWERED]: EVENT_FIELDS.FORM_IDENTITY_QUESTIONS_ANSWERED,
  [profileFields.LAST_NAME]: EVENT_FIELDS.FORM_LAST_NAME,
  [profileFields.LENDAGE_ELIGIBLE]: EVENT_FIELDS.LENDAGE_ELIGIBLE,
  [profileFields.PAYMENT_DATE]: EVENT_FIELDS.FORM_PAYMENT_DATE,
  [profileFields.PHONE]: EVENT_FIELDS.FORM_PHONE,
  [profileFields.SOCIAL_SECURITY]: EVENT_FIELDS.FORM_SOCIAL_SECURITY,
  [profileFields.STATE]: EVENT_FIELDS.FORM_STATE,
  [profileFields.SUIP_ELIGIBLE]: EVENT_FIELDS.SUIP_ELIGIBLE,
  [profileFields.ZIPCODE]: EVENT_FIELDS.FORM_ZIPCODE
};
const convertProfileToAnalyticsPayload = (profile) => {
  if (!profile) {
    return {};
  }
  const result = {};
  for (const [key, value] of Object.entries(profile)) {
    if (value && profileToAnalyticsMapping[key]) {
      result[profileToAnalyticsMapping[key]] = value;
    }
  }
  return result;
};
export {
  convertProfileToAnalyticsPayload,
  profileToAnalyticsMapping
};
